import {
	CircleFlagsIcon,
	DiscountIcon,
	LocationIcon,
	MailIcon,
	PhoneIcon,
	ProfileIcon,
	ThumbsIcon,
} from '@/assets/icons'
import Footer from '@/components/footer'
import Header from '@/components/header'
import { Link } from 'react-router-dom'

export const Impressum = () => {
	return (
		<div className="bg-landing-page bg-cover bg-no-repeat">
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="kontakt" />
				<div className="mt-5 lg:mt-[90px] flex items-center flex-col gap-3 lg:gap-2">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Impressum
					</h1>
					<p className="text-secondary text-center text-sm lg:text-xl font-medium">
						Kontakt zum Support-Team von minmini
					</p>
				</div>
				<p className="text-muted-foreground max-lg:mx-5 lg:max-w-5xl mx-auto text-center text-sm lg:text-xl font-medium mt-6 lg:mt-8">
					Sie können das Support-Team von minmini über unsere Kontaktmöglichkeiten erreichen. Unser
					Team freut sich darauf, Ihre Meinungen, Anregungen und Feedback zu hören.
				</p>
				<div className="grid lg:grid-flow-col grid-rows-1 grid-cols-1 lg:grid-rows-2 mx-5 lg:mx-20 lg:grid-cols-3 gap-4 lg:gap-5 mt-6 lg:mt-16">
					<div className="lg:row-span-2 rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
						<div className="flex items-center gap-2">
							<LocationIcon className="max-lg:size-10" />
							<h2 className="text-secondary text-xs lg:text-xl font-extrabold">
								Angaben gemäß § 5 TMG
							</h2>
						</div>
						<div className="text-muted-foreground max-lg:text-xs font-medium leading-[26px] flex flex-col gap-1">
							<span>Mirzoyan GbR, Kieler Straße 113, 24119 Kronshagen</span>
							<span className="flex flex-col gap-0.5">
								<span className="flex gap-2">
									<span className="w-[16ch] shrink-0">Montag - Freitag:</span>
									<span className="flex flex-col">
										<span>10:00 - 13:00 Uhr</span>
										<span>14:00 - 18:00 Uhr</span>
									</span>
								</span>
								<span className="flex gap-2">
									<span className="w-[16ch] shrink-0">Samstag:</span>
									<span>10:00 - 15:00 Uhr</span>
								</span>
							</span>
						</div>
					</div>
					<div className="rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
						<div className="flex items-center gap-2">
							<PhoneIcon className="max-lg:size-10" />
							<h2 className="text-secondary text-xs lg:text-xl font-extrabold">Telefon</h2>
						</div>
						<p className="text-muted-foreground max-lg:text-xs font-medium leading-[26px]">
							0431 - 59674213
						</p>
					</div>
					<div className="rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
						<div className="flex items-center gap-2">
							<MailIcon className="max-lg:size-10" />
							<h2 className="text-secondary text-xs lg:text-xl font-extrabold">E-Mail:</h2>
						</div>
						<div className="flex flex-col gap-1 text-xs 2xl:text-sm">
							<p className="flex flex-wrap gap-1.5">
								<span className="text-secondary">Allgemeine Anfragen:</span>
								<span className="text-secondary font-extrabold">support@minmini.de</span>
							</p>
							<p className="flex flex-wrap gap-1.5">
								<span className="text-secondary">Geschäftliche Anfragen:</span>
								<span className="text-secondary font-extrabold">info@minmini.de</span>
							</p>
						</div>
					</div>
					<div className="lg:row-span-2 rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
						<div className="flex items-center gap-2">
							<ProfileIcon className="max-lg:size-10" />
							<h2 className="text-secondary text-xs lg:text-xl font-extrabold">Vertreten durch:</h2>
						</div>
						<ol className="text-muted-foreground max-lg:text-xs font-medium list-inside list-decimal leading-[26px]">
							<li>Edgar Mirzoyan</li>
							<li>Christina Mirzoyan</li>
							<li>Mikael Mirzoyan</li>
						</ol>
					</div>
				</div>
				<div className="mt-16 lg:mt-[120px]">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Rechtliche Informationen
					</h1>
					<div className="grid grid-rows-1 grid-cols-1 lg:grid-rows-2 mt-6 lg:mt-9 lg:grid-flow-col lg:grid-cols-2 mx-5 lg:mx-[152px] gap-5">
						<div className="rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
							<div className="flex items-center gap-2">
								<DiscountIcon className="max-lg:size-10" />
								<h2 className="text-secondary text-xs lg:text-xl font-extrabold">
									Umsatzsteuer-Identifikationsnummer gem. § 27a UStG:
								</h2>
							</div>
							<p className="text-muted-foreground max-lg:text-xs font-medium leading-[26px]">
								DE 361131804
							</p>
						</div>
						<div className="rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
							<div className="flex items-center gap-2">
								<ThumbsIcon className="max-lg:size-10" />
								<h2 className="text-secondary text-xs lg:text-xl font-extrabold">
									Verbraucherstreitbeilegung / Universalschlichtungsstelle
								</h2>
							</div>
							<p className="text-muted-foreground max-lg:text-xs font-medium leading-[26px]">
								Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
								Verbraucherschlichtungsstelle teilzunehmen.
							</p>
						</div>
						<div className="lg:row-span-2 rounded-[20px] bg-[#F8F9F6] pr-5 max-lg:py-4 max-lg:px-3 lg:p-6 flex flex-col gap-6">
							<div className="flex items-center gap-2">
								<CircleFlagsIcon className="max-lg:size-10" />
								<h2 className="text-secondary text-xs lg:text-xl font-extrabold">
									EU-Streitschlichtung
								</h2>
							</div>
							<p className="text-muted-foreground max-lg:text-xs font-medium leading-[26px]">
								Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
								bereit:
								<br />
								<Link
									to="https://ec.europa.eu/consumers/odr/"
									className="text-secondary underline font-extrabold"
									target="__blank">
									https://ec.europa.eu/consumers/odr/
								</Link>
								<br />
								Unsere E-Mail-Adresse finden Sie oben im Impressum.
								<br />
								<br />
								Quelle:{' '}
								<Link
									to="https://e-recht24.de"
									className="text-secondary underline font-extrabold"
									target="__blank">
									e-recht24.de
								</Link>
							</p>
						</div>
					</div>
				</div>
				<div className="mt-16 lg:mt-[141px] bg-[#E6E6E6] w-full h-px" />
				<Footer />
			</div>
		</div>
	)
}
